import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-form" }
const _hoisted_5 = { class: "wrapper-image upload1" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "wrapper-campaign-image position1" }
const _hoisted_8 = { class: "grid-image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "no-image"
}
const _hoisted_12 = { class: "wrapper-image upload2" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "wrapper-campaign-image position2" }
const _hoisted_15 = { class: "grid-image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "no-image"
}
const _hoisted_19 = { class: "wrapper-image upload3" }
const _hoisted_20 = { class: "info" }
const _hoisted_21 = { class: "wrapper-campaign-image position3" }
const _hoisted_22 = { class: "grid-image" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 2,
  class: "no-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralInput = _resolveComponent("GeneralInput")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "title" }, "Información de campaña", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_GeneralInput, {
          text: _ctx.name.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name.val) = $event)),
          value: _ctx.name.val,
          label: 'Nombre',
          "has-error": _ctx.name.enabled,
          error: _ctx.name.errors.length === 0 ? '' : _ctx.name.errors[0],
          class: "input-name",
          "is-disabled": _ctx.isEdit
        }, null, 8, ["text", "value", "has-error", "error", "is-disabled"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Imagen campaña", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.fileIcon.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileIcon",
              hidden: "",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadIcon && _ctx.uploadIcon(...args))),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("figure", _hoisted_8, [
            (_ctx.showIconPreview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewIcon,
                  class: "campaign-image"
                }, null, 8, _hoisted_9))
              : (_ctx.showIcon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.campaign.icon,
                    class: "campaign-image"
                  }, null, 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, "Sin imagen"))
          ]),
          (_ctx.showIconPreview)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 0,
                class: "delete",
                onClick: _ctx.removeUploadIcon
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Imagen 1", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.fileImage1.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage1",
              hidden: "",
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadImage1 && _ctx.uploadImage1(...args))),
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("figure", _hoisted_15, [
            (_ctx.showImage1Preview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewImage1,
                  class: "campaign-image"
                }, null, 8, _hoisted_16))
              : (_ctx.campaign?.additional_image1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.campaign.additional_image1,
                    class: "campaign-image"
                  }, null, 8, _hoisted_17))
                : (_openBlock(), _createElementBlock("p", _hoisted_18, [...(_cache[15] || (_cache[15] = [
                    _createTextVNode(" Sin imagen.", -1),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" Necesaria para verse en la app móvil. ", -1)
                  ]))]))
          ]),
          (_ctx.showImage1Preview)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 0,
                class: "delete",
                onClick: _ctx.removeUploadImage1
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.campaign?.additional_image1)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 1,
                class: "delete",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteAdditionalImage(1)))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[16] || (_cache[16] = _createElementVNode("p", null, "Imagen 2 (opcional)", -1)),
            _createVNode(_component_SecondaryButton, {
              buttonLabel: 'Subir imagen',
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$refs.fileImage2.click()))
            }),
            _createElementVNode("input", {
              type: "file",
              ref: "fileImage2",
              hidden: "",
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.uploadImage2 && _ctx.uploadImage2(...args))),
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($event.target.value = ''))
            }, null, 544)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("figure", _hoisted_22, [
            (_ctx.showImage2Preview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewImage2,
                  class: "campaign-image"
                }, null, 8, _hoisted_23))
              : (_ctx.campaign?.additional_image2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.campaign.additional_image2,
                    class: "campaign-image"
                  }, null, 8, _hoisted_24))
                : (_openBlock(), _createElementBlock("p", _hoisted_25, "Sin imagen"))
          ]),
          (_ctx.showImage2Preview)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 0,
                class: "delete",
                onClick: _ctx.removeUploadImage2
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.campaign?.additional_image2)
            ? (_openBlock(), _createBlock(_component_DeleteButton, {
                key: 1,
                class: "delete",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteAdditionalImage(2)))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Guardar',
        class: "margin-button",
        "is-disabled": _ctx.disabledForm,
        onClick: _ctx.createEditCampaign
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}